<template>
    <q-dialog v-model="model" persistent>
        <q-card class="prorrateo-dialog" style="max-width: 95vw; height: 90vh; display: flex; flex-direction: column;">
            <!-- Header mejorado - FIJO -->
            <q-toolbar class="bg-gradient-primary text-white toolbar-fixed">
                <q-icon name="engineering" size="28px" class="q-mr-sm" />
                <q-toolbar-title>
                    <div class="text-h6">Items de Ingeniería</div>
                    <div class="text-caption text-white-7">Distribución de costos y confirmación</div>
                </q-toolbar-title>

                <!-- Badge con estado -->
                <q-badge color="white" text-color="primary" class="q-mr-md q-px-md q-py-sm">
                    <q-icon name="inventory_2" size="16px" class="q-mr-xs" />
                    {{ rows.length }} items
                </q-badge>

                <q-btn dense flat icon="close" v-close-popup>
                    <q-tooltip>Cerrar (ESC)</q-tooltip>
                </q-btn>
            </q-toolbar>

            <!-- Contenido scrolleable -->
            <div class="row no-wrap content-scrollable">
                <!-- Columna principal: Tabla de items -->
                <div class="col-12 col-md-8 q-pa-md scroll-area">
                    <!-- Sección: Datos de Cámara -->
                    <q-expansion-item default-opened icon="ac_unit" label="Información de Cámara"
                        header-class="bg-grey-2 text-primary text-weight-medium"
                        class="q-mb-md rounded-borders overflow-hidden">
                        <q-card flat bordered>
                            <q-card-section>
                                <div class="row q-col-gutter-md">
                                    <!-- Tipo y cantidad -->
                                    <div class="col-12 col-md-6">
                                        <div class="info-field">
                                            <q-icon name="category" color="primary" size="20px" class="q-mr-sm" />
                                            <div>
                                                <div class="text-caption text-grey-7">Tipo de Cámara</div>
                                                <div class="text-body2 text-weight-medium">
                                                    {{ tipoCamara }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="info-field">
                                            <q-icon name="numbers" color="primary" size="20px" class="q-mr-sm" />
                                            <div>
                                                <div class="text-caption text-grey-7">Cantidad</div>
                                                <div class="text-body2 text-weight-medium">
                                                    {{ producto?.cantidad || 1 }} unidad(es)
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Dimensiones (si tiene largo, ancho, alto) -->
                                    <template v-if="tieneDimensiones">
                                        <div class="col-12 col-md-4">
                                            <div class="info-field">
                                                <q-icon name="straighten" color="blue" size="20px" class="q-mr-sm" />
                                                <div>
                                                    <div class="text-caption text-grey-7">Largo</div>
                                                    <div class="text-body2 text-weight-medium">
                                                        {{ producto?.largo }} m
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <div class="info-field">
                                                <q-icon name="height" color="blue" size="20px" class="q-mr-sm" />
                                                <div>
                                                    <div class="text-caption text-grey-7">Ancho</div>
                                                    <div class="text-body2 text-weight-medium">
                                                        {{ producto?.ancho }} m
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <div class="info-field">
                                                <q-icon name="architecture" color="blue" size="20px" class="q-mr-sm" />
                                                <div>
                                                    <div class="text-caption text-grey-7">Alto</div>
                                                    <div class="text-body2 text-weight-medium">
                                                        {{ producto?.alto }} m
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="calculated-field-inline">
                                                <q-icon name="view_in_ar" color="primary" size="24px" />
                                                <div class="flex-1">
                                                    <div class="text-caption text-grey-7">Volumen (m³)</div>
                                                    <div class="text-h6 text-primary text-weight-bold">
                                                        {{ volumenCalculado }} m³
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Paneles -->
                                    <div class="col-12">
                                        <q-separator class="q-my-sm" />
                                        <div class="text-subtitle2 text-grey-8 q-mb-sm">
                                            <q-icon name="grid_on" class="q-mr-xs" />
                                            Paneles ({{ panelesCount }})
                                        </div>
                                        <div class="text-body2">
                                            Total m²: <span class="text-weight-medium text-primary">{{ totalM2 }}
                                                m²</span>
                                        </div>
                                    </div>

                                    <!-- Opciones activas -->
                                    <div class="col-12" v-if="hasOptions">
                                        <q-separator class="q-my-sm" />
                                        <div class="text-subtitle2 text-grey-8 q-mb-sm">
                                            <q-icon name="settings" class="q-mr-xs" />
                                            Opciones Activas
                                        </div>
                                        <div class="row q-gutter-xs">
                                            <q-chip v-if="producto?.perfileria_ext" color="blue-2" text-color="blue-9"
                                                size="sm">
                                                <q-icon name="border_outer" size="16px" class="q-mr-xs" />
                                                Perfilería Exterior
                                                <q-badge color="blue-9"
                                                    :label="numberFormat(producto?.perfileria_ext_valor)"
                                                    class="q-ml-xs" />
                                            </q-chip>
                                            <q-chip v-if="producto?.perfileria_int" color="blue-2" text-color="blue-9"
                                                size="sm">
                                                <q-icon name="border_inner" size="16px" class="q-mr-xs" />
                                                Perfilería Interior
                                                <q-badge color="blue-9"
                                                    :label="numberFormat(producto?.perfileria_int_valor)"
                                                    class="q-ml-xs" />
                                            </q-chip>
                                            <q-chip v-if="producto?.selladores && parseFloat(producto?.selladores) > 0"
                                                color="orange-2" text-color="orange-9" size="sm">
                                                <q-icon name="construction" size="16px" class="q-mr-xs" />
                                                Selladores
                                                <q-badge color="orange-9" :label="numberFormat(producto?.selladores)"
                                                    class="q-ml-xs" />
                                            </q-chip>
                                        </div>
                                    </div>
                                </div>
                            </q-card-section>
                        </q-card>
                    </q-expansion-item>

                    <!-- Sección: Tabla de Items de Ingeniería -->
                    <q-expansion-item default-opened icon="list_alt" :label="`Items de Ingeniería (${rows.length})`"
                        :caption="`Total: ${numberFormat(totalPrecio)}`"
                        header-class="bg-grey-2 text-primary text-weight-medium"
                        class="rounded-borders overflow-hidden">
                        <q-card flat bordered>
                            <q-card-section class="q-pa-none">
                                <q-markup-table flat wrap-cells class="modern-table">
                                    <thead>
                                        <tr>
                                            <th class="text-left">Producto</th>
                                            <th class="text-left">Largo Pieza</th>
                                            <th class="text-left">Ancho</th>
                                            <th class="text-left">M²</th>
                                            <th class="text-right">Cantidad</th>
                                            <th class="text-right">Total M²</th>
                                            <th class="text-right">Precio Unitario</th>
                                            <th class="text-right">Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, index) in rows" :key="index" class="table-row-hover">
                                            <td>
                                                <div class="product-cell">
                                                    <div class="product-name">{{ row.producto.B1_DESC }}</div>
                                                    <div class="text-caption text-grey-6">{{ row.producto.B1_COD }}
                                                    </div>
                                                </div>
                                            </td>
                                            <td class="text-right">{{ row.producto.es_panel ? numberFormat(row.largo_pieza, true) : '-'
                                                }}</td>
                                            <td class="text-right">{{ row.producto.es_panel ? numberFormat(row.producto.B1_ANCHO, true) : '-'
                                                }}</td>
                                            <td class="text-right">{{ row.producto.es_panel ? numberFormat(row.largo_pieza * row.producto.B1_ANCHO, true) : '-' }}
                                            </td>
                                            <td class="text-right">{{ numberFormat(row.cantidad, true) }}</td>
                                            <td class="text-right">{{ numberFormat(row.largo_pieza * row.producto.B1_ANCHO * row.cantidad, true) }}</td>
                                            <td class="text-right">{{ numberFormat(row.precio_unitario) }}</td>
                                            <td class="text-right text-green-9 text-weight-bold">{{
                                                numberFormat(row.total) }}
                                            </td>
                                        </tr>
                                        <tr class="totals-row">
                                            <td colspan="5" class="text-right text-weight-bold">TOTALES</td>

                                            <td class="text-right text-weight-bold text-blue-9">
                                                {{ numberFormat(totalM2,true) }}
                                            </td>
                                            <td class="text-center text-weight-bold text-blue-9">-</td>
                                            <td class="text-right text-weight-bold text-blue-9">
                                                {{ numberFormat(totalPrecioPonderado) }}
                                            </td>
                                            <td class="text-right text-weight-bold text-green-9">
                                                {{ numberFormat(totalPonderado) }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </q-markup-table>
                            </q-card-section>
                        </q-card>
                    </q-expansion-item>
                </div>

                <!-- Columna lateral: Resumen -->
                <div class="col-12 col-md-4 bg-grey-1 q-pa-md gt-sm scroll-area">
                    <div class="sticky-summary">
                        <q-card flat bordered class="summary-card">
                            <q-card-section class="bg-primary text-white">
                                <div class="text-h6">
                                    <q-icon name="calculate" size="24px" class="q-mr-sm" />
                                    Resumen Financiero
                                </div>
                            </q-card-section>

                            <q-separator />

                            <q-card-section>
                                <!-- Precio Cámara -->
                                <div class="summary-row">
                                    <span class="text-grey-8">
                                        <q-icon name="ac_unit" size="18px" class="q-mr-xs" />
                                        Precio Cámara
                                    </span>
                                    <span class="text-h6 text-primary text-weight-bold">
                                        {{ numberFormat(producto?.total) }}
                                    </span>
                                </div>

                                <q-separator class="q-my-md" />

                                <!-- Total Items -->
                                <div class="summary-row">
                                    <span class="text-grey-8">Total Items</span>
                                    <span class="text-weight-medium">{{ numberFormat(totalPrecio) }}</span>
                                </div>

                                <!-- Total Ponderado -->
                                <div class="summary-row">
                                    <span class="text-grey-8">Total Ponderado</span>
                                    <span class="text-weight-medium text-green-9">{{ numberFormat(totalPonderado)
                                        }}</span>
                                </div>

                                <q-separator class="q-my-md" />

                                <!-- Diferencia -->
                                <div class="summary-row">
                                    <span class="text-grey-8">
                                        <q-icon name="compare_arrows" size="18px" class="q-mr-xs" />
                                        Diferencia
                                    </span>
                                    <span class="text-weight-bold"
                                        :class="diferencia >= 0 ? 'text-positive' : 'text-negative'">
                                        {{ numberFormat(diferencia) }}
                                    </span>
                                </div>

                                <!-- Porcentaje de diferencia -->
                                <div class="summary-row">
                                    <span class="text-grey-8">% Diferencia</span>
                                    <span class="text-weight-medium"
                                        :class="diferencia >= 0 ? 'text-positive' : 'text-negative'">
                                        {{ porcentajeDiferencia }}%
                                    </span>
                                </div>
                            </q-card-section>

                            <q-separator />

                            <q-card-section class="q-pa-sm">
                                <q-linear-progress :value="Math.abs(porcentajeDiferencia) / 100"
                                    :color="diferencia >= 0 ? 'positive' : 'negative'" size="8px" rounded />
                                <div class="text-caption text-center text-grey-7 q-mt-xs">
                                    {{ diferencia >= 0 ? 'Superávit' : 'Déficit' }}
                                </div>
                            </q-card-section>
                        </q-card>

                        <!-- Card de ayuda -->
                        <q-card flat bordered class="q-mt-md">
                            <q-card-section class="bg-blue-1">
                                <div class="text-subtitle2 text-primary">
                                    <q-icon name="info" class="q-mr-xs" />
                                    Información
                                </div>
                            </q-card-section>
                            <q-card-section>
                                <ul class="text-caption text-grey-8 q-pl-md q-my-none">
                                    <li>El precio ponderado distribuye el costo total</li>
                                    <li>La diferencia muestra el ajuste necesario</li>
                                    <li>Confirmar aplicará los cambios permanentemente</li>
                                </ul>
                            </q-card-section>
                        </q-card>
                    </div>
                </div>
            </div>

            <!-- Footer con acciones - FIJO -->
            <q-separator />
            <q-card-actions class="q-pa-md actions-fixed bg-white">
                <div class="row full-width q-gutter-sm">
                    <div class="col">
                        <q-btn outline label="Cerrar" color="grey-7" icon="close" v-close-popup class="full-width" />
                    </div>
                </div>
            </q-card-actions>

            <q-inner-loading :showing="loading">
                <q-spinner-hourglass size="50px" color="primary" />
            </q-inner-loading>
        </q-card>
    </q-dialog>
</template>
<script setup>
import IngenieriaService from "@/services/IngenieriaService";
import numberFormat from "@/helpers/numberFormat";
import { ref, computed, watch } from "vue";

const model = defineModel({ type: Boolean, default: false })
const emit = defineEmits(['updated'])
const rows = ref([])
const producto = ref({})
const loading = ref(false)
const props = defineProps({
    ingenieriaId: {
        type: Number,
        required: true,
    },
})

watch(model, async (newVal) => {
    if (!newVal) return
    // Cargar los items de ingeniería cuando se abra el diálogo
    loading.value = true
    try {
        const {items, presupuesto_item} = await IngenieriaService.show(props.ingenieriaId);
        rows.value = items;
        producto.value = presupuesto_item;
    } catch (error) {
        console.error('Error al cargar los items de ingeniería:', error);
    }finally{
        loading.value = false
    }
},{immediate:true});

// Computed properties para datos de cámara
const tipoCamara = computed(() => {
    // Determinar tipo por la presencia de dimensiones
    if (producto.value?.largo && producto.value?.ancho && producto.value?.alto) {
        return 'Convencional';
    }
    return 'No Convencional';
});

const tieneDimensiones = computed(() => {
    return producto.value?.largo && producto.value?.ancho && producto.value?.alto;
});

const volumenCalculado = computed(() => {
    if (!tieneDimensiones.value) return '0.00';
    const volumen = parseFloat(producto.value.largo || 0) *
        parseFloat(producto.value.ancho || 0) *
        parseFloat(producto.value.alto || 0);
    return volumen.toFixed(2);
});

const panelesCount = computed(() => {
    return rows.value?.length || 0;
});

const totalM2 = computed(() => {
    return rows.value.reduce((acc, panel) => acc + (panel.m2total || 0), 0).toFixed(2);
});

const hasOptions = computed(() => {
    return producto.value?.perfileria_ext ||
        producto.value?.perfileria_int ||
        (producto.value?.selladores && parseFloat(producto.value.selladores) > 0);
});

// Computed properties para totales
const totalPrecio = computed(() => {
    return rows.value.reduce((acc, item) => acc + item.precio, 0);
});

const totalPrecioPonderado = computed(() => {
    return rows.value.reduce((acc, item) => acc + item.precio_ponderado, 0);
});

const totalPonderado = computed(() => {
    return rows.value.reduce((acc, item) => acc + item.total_ponderado, 0);
});

const diferencia = computed(() => {
    return Math.round(totalPonderado.value * 100) / 100 - (totalPrecio.value || 0);
});

const porcentajeDiferencia = computed(() => {
    if (!producto.value?.total) return 0;
    return ((diferencia.value / producto.value.total) * 100).toFixed(2);
});

</script>

<style lang="scss" scoped>
@use 'sass:color';

.prorrateo-dialog {
    border-radius: 16px;
    overflow: hidden;

    // Gradiente para el header
    .bg-gradient-primary {
        background: linear-gradient(135deg, var(--q-primary) 0%, color.adjust(#1976d2, $lightness: -10%) 100%);
    }

    // Toolbar fijo arriba
    .toolbar-fixed {
        flex-shrink: 0;
        position: sticky;
        top: 0;
        z-index: 100;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    // Contenido scrolleable
    .content-scrollable {
        flex: 1;
        overflow: hidden;
    }

    .scroll-area {
        overflow-y: auto;
        max-height: 100%;

        &::-webkit-scrollbar {
            width: 8px;
        }

        &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 4px;
        }

        &::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 4px;

            &:hover {
                background: #555;
            }
        }
    }

    // Acciones fijas abajo
    .actions-fixed {
        flex-shrink: 0;
        box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
    }
}

// Mejora de tipografía
.text-white-7 {
    color: rgba(255, 255, 255, 0.7);
}

// Sticky summary en desktop
.sticky-summary {
    position: sticky;
    top: 20px;
}

// Card de resumen
.summary-card {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

// Filas del resumen
.summary-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    gap: 16px;

    &:not(:last-child) {
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    }

    span:first-child {
        flex: 1;
    }

    span:last-child {
        text-align: right;
        word-break: break-word;
    }
}

// Info fields
.info-field {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 12px;
    background: #f5f5f5;
    border-radius: 8px;
    border-left: 3px solid var(--q-primary);
}

// Campo calculado inline
.calculated-field-inline {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 16px;
    background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
    border-radius: 8px;
    border-left: 4px solid #1976d2;
}

// Tablas modernas
.modern-table {
    border-radius: 8px;
    overflow: hidden;

    :deep(thead) {
        background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);

        tr th {
            color: white;
            font-weight: 600;
            padding: 12px;
            text-transform: uppercase;
            font-size: 0.75rem;
        }
    }

    :deep(tbody) {
        tr {
            transition: background-color 0.2s ease;

            &.table-row-hover:hover {
                background-color: rgba(25, 118, 210, 0.04);
            }

            &.totals-row {
                background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
                font-size: 1rem;

                td {
                    padding: 12px;
                    border-top: 2px solid #1976d2;
                }
            }
        }
    }
}

// Celdas de producto
.product-cell {
    .product-name {
        font-weight: 500;
        color: #212121;
    }
}

// Expansion items
:deep(.q-expansion-item) {
    border: 1px solid rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;

    &.q-expansion-item--expanded {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }

    .q-expansion-item__container {
        .q-item {
            min-height: 56px;
        }
    }
}

// Responsive
@media (max-width: 1023px) {
    .prorrateo-dialog {
        border-radius: 0;
    }

    .sticky-summary {
        position: relative;
        top: 0;
    }
}
</style>
